import React from 'react';
import { Autocomplete, Button, Container, FormControl, InputLabel, OutlinedInput, Stack, TextField, Typography } from '@mui/material';
import { format, parse } from 'date-fns';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

const AddDHQExpense = () => {

    const { register, handleSubmit, formState: { errors } } = useForm();
    const presentDate = format(new Date(), 'yyyy-MM-dd HH:mm');
    const navigate = useNavigate();
    const allExpensesUrl = 'https://lantabur-house-server.vercel.app/getConstructionExpenses';

    const { data: rows = [] } = useQuery({
        queryKey: ['Expenses'],
        queryFn: async () => {
            const response = await fetch(allExpensesUrl);
            const data = await response.json();
            return data;
        }
    });

    const purposes = [...new Set(rows?.map(({ purpose }) => purpose))];
    const subPurposes = [...new Set(rows?.map(({ subPurpose }) => subPurpose))].filter(function(x) {return x !== undefined});
    

    const handleRegistration = (data) => {
        data.date = format(parse(data.date, "yyyy-MM-dd'T'HH:mm", new Date()), 'dd/MM/yy p');
        data.postingTime = format(new Date(), 'dd/MM/yy p');
        data.amount = parseInt(data.amount);
        axios.post('http://localhost:5000/AddDhqExpense', data)
            .then(() => {
                toast.success('Saved');
                navigate('/DHQexpenses');
            })
            .catch(error => {
                toast.error('There is an error. Check console.log in developer tools. ')
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                }

                else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.log(error.request);
                }

                else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message);
                }
                console.log(error.config);
            });

    }

    return (
    
        <Container maxWidth='sm'>
            <Stack spacing={2} component={'form'} onSubmit={handleSubmit(handleRegistration)} alignItems='center'>

                <FormControl fullWidth>
                    <InputLabel> Date </InputLabel>
                    <OutlinedInput type='datetime-local' defaultValue={presentDate} label='Date' {...register("date", { required: "There must be a time, when you comitted an expense." })} autoFocus />
                    {errors.date && <Typography color='error'> {errors.date.message} </Typography>}
                </FormControl>
                <FormControl fullWidth>
                    <InputLabel> Reciever </InputLabel>
                    <OutlinedInput label='Reciever' {...register("receiver", { required: "Whom did you give the money? " })} />
                    {errors.receiver && <Typography color='error'> {errors.receiver.message} </Typography>}
                </FormControl>
                <FormControl fullWidth>
                    <Autocomplete
                        options={purposes}
                        renderInput={(params) => <TextField {...params} label='Purpose' {...register("purpose")} />}
                    />
                </FormControl>
                <FormControl fullWidth>
                    <Autocomplete
                        options={subPurposes}
                        renderInput={(params) => <TextField {...params} label='Sub Purpose' {...register("subPurpose")} />}
                    />                    
                </FormControl>
                <FormControl fullWidth>
                    <InputLabel> Description </InputLabel>
                    <OutlinedInput label='Description' {...register("description", { required: "Tell me some details about this expense" })} />
                    {errors.description && <Typography color='error'> {errors.description.message} </Typography>}
                </FormControl>
                <FormControl fullWidth>
                    <InputLabel> Sub Description </InputLabel>
                    <OutlinedInput label='Sub Description' {...register("subDescription")} />
                </FormControl>
                <FormControl fullWidth>
                    <InputLabel> Expensed By </InputLabel>
                    <OutlinedInput defaultValue={"Asad"} label='Expensed By' {...register("spentBy")} />
                </FormControl>
                <FormControl fullWidth>
                    <InputLabel> Amount </InputLabel>
                    <OutlinedInput type='number' label='Amount' {...register("amount", { require: "Provide the amount you spent" })} />
                    {errors.amount && <Typography color='error'> {errors.amount.message} </Typography>}
                </FormControl>



                <Button type='submit' variant='contained' color='success' sx={{ width: { xs: '100%', sm: '66%' } }} > Add Expense </Button>
            </Stack>
        </Container>
        
    );
};

export default AddDHQExpense;